var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:( _obj = {
  'btn-block': _vm.block,
  'btn-lg': _vm.large,
  'btn-loading': _vm.loading
}, _obj[("btn-" + _vm.type)] = true, _obj ),attrs:{"type":_vm.nativeType,"disabled":_vm.loading}},[_vm._t("default")],2)
var _obj;}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c4c923d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Button.vue
// module id = x612
// module chunks = 97